"use strict";
/**
 * Shared contract for ediabasx API — implemented by `EdiabasClient`
 * (remote JSON-RPC) and `EmbeddedEdiabas` (in-process). Mirrors the
 * EDIABAS C API without the `api` prefix, minus config/device switching
 * (those are startup-time concerns).
 *
 * `job(...)` covers both `apiJob` (string params, read via the SGBD's
 * `pari` / `pars` opcodes) and `apiJobData` (binary params, read via
 * `pary` / `parb` / `parw` / `parl` / `parr`). Callers pick the channel
 * by the element type they hand in: a string entry lands in the indexed-
 * string params, a `Uint8Array` entry lands in the binary payload.
 * Bare `string` and bare `Uint8Array` are shorthand for "all params on
 * one channel"; the array form interleaves both.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ediabas-api.js.map